const Ambient = () => (
  <div className="ambient">
    <span className="orb orb--one" />
    <span className="orb orb--two" />
    <span className="orb orb--three" />
  </div>
);

export default Ambient;
